import { useHistory } from 'react-router-dom'
import { IconArrowLeft } from '../../../assets/icons'
import { useAppParamsContext } from '../../../context/AppParamsContext'
import './index.scss'

export default function HeaderPartner({ title, noBackground = false, onGoBack }) {
  const history = useHistory()
  const { isEmbeddedView } = useAppParamsContext()

  // Check if embedded view - hide header
  if (isEmbeddedView) {
    return null
  }

  return (
    <div className="HeaderPartner">
      <div className="HeaderPartner_fixed">
        {!noBackground && <div className="HeaderPartner_fixed_bg"></div>}

        <div className="HeaderPartner_fixed_content">
          <IconArrowLeft
            className={`${noBackground ? 'iconDark' : ''}`}
            onClick={() => {
              if (onGoBack) {
                onGoBack()
              } else {
                history.goBack()
              }
            }}
          />
          <div className="HeaderPartner_fixed_content_title">{title}</div>
          <div className="HeaderPartner_fixed_content_right"></div>
        </div>
      </div>
      <div className="HeaderPartner_padding"></div>
    </div>
  )
}
